import React, { Fragment, useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import Breadcum from "../common/breadcum";
import {
  getGroups,
  deleteGroup,
  changeActiveGroup,
} from "../../services/groupService";
import { Container } from "@material-ui/core";
import { notifications } from "../../utils/messages";
import GroupsTableI from "./groupsTableI";

const GroupsI = () => {
  const [groups, setGroups] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const getGroup = (id) => {
    return groups.find((g) => g.id === id);
  };

  const changeActive = (idGroup, groups) => {
    const group = getGroup(idGroup);
    const index = groups.indexOf(group);
    groups[index] = { ...groups[index] };
    if (groups[index].active === 1) {
      groups[index].active = 0;
    } else if (groups[index].active === 0) {
      groups[index].active = 1;
    } else {
      groups[index].active = 3;
    }
    return groups;
  };

  const handleActive = async (idGroup) => {
    const originalGroups = groups;
    const copyGroups = [...groups];
    setGroups(changeActive(idGroup, copyGroups));
    try {
      await changeActiveGroup(idGroup);
    } catch (ex) {
      if (ex.response && ex.response.status === 404) console.log("x");
      enqueueSnackbar(`${ex.response.data.message}`, {
        variant: "error",
      });
      setGroups(originalGroups);
    }
  };

  const handleUndo = (groupsToDelete, originalGroups) => {
    const action = (key) => <Fragment></Fragment>;
    const lenghtArray = groupsToDelete.length;
    const mensaje =
      lenghtArray === 1
        ? notifications.DELETE_SUCCESS
        : `${lenghtArray} registros eliminados`;
    enqueueSnackbar(mensaje, {
      autoHideDuration: 3000,
      action,
      variant: "success",
    });
  };

  const handleDelete = async (groupsToDelete) => {
    const originalGroups = [...groups];
    const newGroups = originalGroups.filter(
      (group) => !groupsToDelete.includes(group)
    );
    setGroups(newGroups);
    groupsToDelete.forEach(async (group) => {
      try {
        await deleteGroup(group.id);
        // this.handleUndo(groupsToDelete, originalGroups);
      } catch (ex) {
        if (ex.response && ex.response.status === 404) console.log(ex);
        enqueueSnackbar(`${ex.response.data.message}`, {
          variant: "error",
        });
        setGroups(originalGroups);
      }
    });
    handleUndo(groupsToDelete, originalGroups);
  };

  const populateGroups = async () => {
    setIsLoading(true);
    const { data: groups } = await getGroups();
    setGroups(groups);
    setIsLoading(false);
  };

  useEffect(() => {
    populateGroups();
  }, []);

  const classes = {
    table: {
      padding: "2em",
      color: "secondary",
    },
  };

  return (
    <Container maxWidth="xl">
      <Breadcum lastLabel={"Grupos"} />
      <GroupsTableI
        datas={groups}
        onLoading={isLoading}
        onActive={handleActive}
        style={classes.table}
        onDelete={handleDelete}
      />
    </Container>
  );
};

export default GroupsI;
